module.exports = __webpack_public_path__ + "img/pic1.3c4966aa.jpg";